export const toSellSurvey = {
  // Survey base
  'to_sell_survey.loading': 'Probíhá načítání dat',
  'to_sell_survey.restore_previous.title':
    'Chcete pokračovat v rozpracovaném formuláři?',
  'to_sell_survey.restore_previous.subtitle':
    'Máte rozpracovaný formulář na poptávku, chcete v něm pokračovat nebo začít znovu?',
  'to_sell_survey.restore_previous.estate_info': 'Jedná se o nemovitost:',
  'to_sell_survey.restore_previous.continue': 'Pokračovat',
  'to_sell_survey.restore_previous.cancel': 'Začít znovu',
  // Generic fields
  'to_sell_survey.field.yes': 'Ano',
  'to_sell_survey.field.no': 'Ne',
  'to_sell_survey.field.maybe': 'Možná',

  // estate selection step
  'to_sell_survey.steps.estate_selection.loading.title': 'Chvilku strpení...',
  'to_sell_survey.steps.estate_selection.loading.subtitle':
    'Ověřujeme, jaké nemovitosti sledujete...',
  'to_sell_survey.steps.estate_selection.loading.error':
    'Při načítání nemovitostí došlo k chybě, zkuste to prosím znovu později.',
  'to_sell_survey.steps.estate_selection.title':
    'Vyberte nemovitost u které zvažujete prodej',
  'to_sell_survey.steps.estate_selection.subtitle':
    'Můžete vybrat jednu ze sledovaných nemovitostí, nebo vytvořit novou poptávku volbou „Jiná&nbsp;nemovitost“.',

  // estate selection fields
  'to_sell_survey.steps.estate_selection.options.other': 'Jiná nemovitost',
  'to_sell_survey.steps.estate_selection.required':
    'Vyberte prosím nemovitost.',

  // Sell horizon step
  'to_sell_survey.steps.sell_horizon.title':
    'Jak rychle chcete nemovitost prodat?',
  'to_sell_survey.steps.sell_horizon.required':
    'Vyplňte prosím časový horizont, ve kterém chcete prodat',

  // Is owner step
  'to_sell_survey.steps.is_owner.title': 'Jste majitel?',
  'to_sell_survey.steps.is_owner.required':
    'Vyplňte prosím zda jste majitelem nemovitosti',
  'to_sell_survey.steps.is_owner.yes': 'Ano',
  'to_sell_survey.steps.is_owner.no': 'Ne',
  'to_sell_survey.steps.is_owner.represent': 'Zastupuji majitele',

  // Owners approval step
  'to_sell_survey.steps.owners_approval.title':
    'Souhlasí všichni majitelé s prodejem?',
  'to_sell_survey.steps.owners_approval.required':
    'Vyplňte prosím zda všichni majitelé souhlasí s prodejem',

  // Wants broker step
  'to_sell_survey.steps.wants_broker.title':
    'Přemýšlíte o prodeji s realitní kanceláří?',
  'to_sell_survey.steps.wants_broker.required':
    'Vyplňte prosím zda přemýšlíte o prodeji s realitní kanceláří',

  // Already selling step
  'to_sell_survey.steps.already_selling.title':
    'Nabízí se již nemovitost k prodeji?',
  'to_sell_survey.steps.already_selling.required':
    'Vyplňte prosím zda se nemovitost již nabízí k prodeji',
  'to_sell_survey.steps.already_selling.yes_with_broker_exclusive':
    'Ano, mám exkluzivní spolupráci s makléřem',
  'to_sell_survey.steps.already_selling.yes_with_broker_not_exclusive':
    'Ano, mám neexkluzivní spolupráci s makléřem',
  'to_sell_survey.steps.already_selling.yes_i_advertise_it':
    'Ano, inzeruji sám',
  'to_sell_survey.steps.already_selling.no': 'Ne',

  // Price expectation step
  'to_sell_survey.steps.price_expectation.title':
    'Jakou máte představu o ceně?',
  'to_sell_survey.steps.price_expectation.required':
    'Vyplňte prosím vaši cenovou představu.',
  'to_sell_survey.steps.price_expectation.positive':
    'Cenová představa nemůže být záporná.',
  'to_sell_survey.steps.price_expectation.label': 'Představa o ceně',

  // Email step
  'to_sell_survey.steps.email.title': 'Potvrďte váš email',
  'to_sell_survey.steps.email.email': 'E-mail',
  'to_sell_survey.steps.email.email.required': 'Vyplňte prosím váš e-mail',
  'to_sell_survey.steps.email.submit.error':
    'Při odesílání došlo k chybě, zkuse to prosím znovu za pár minut.',

  // Contact step
  'to_sell_survey.steps.contact.title': 'Zadejte vaše jméno a telefon',
  'to_sell_survey.steps.contact.title.confirm': 'Potvrďte vaše jméno a telefon',
  'to_sell_survey.steps.contact.fullname': 'Jméno a příjmení',
  'to_sell_survey.steps.contact.fullname.required':
    'Vyplňte prosím vaše celé jméno.',
  'to_sell_survey.steps.contact.email': 'E-mail',
  'to_sell_survey.steps.contact.email.required': 'Vyplňte prosím váš e-mail',
  'to_sell_survey.steps.contact.phone': 'Telefon',
  'to_sell_survey.steps.contact.phone.required': 'Vyplňte prosím váš telefon',
  'to_sell_survey.steps.contact.phone.valid': 'Telefon je ve špatném tvaru',
  'to_sell_survey.steps.contact.submit.error':
    'Při odesílání došlo k chybě, zkuse to prosím znovu za pár minut.',

  // SMS verification
  'to_sell_survey.steps.sms_verification.title': 'Ověření telefonního čísla',
  'to_sell_survey.steps.sms_verification.subtitle':
    'Na tel. číslo <b>{phoneNumber}</b> jsme zaslali 4-místný SMS kód. Opište prosím kód z SMS pro ověření telefonu.',
  'to_sell_survey.steps.sms_verification.code': 'Kód z SMS',
  'to_sell_survey.steps.sms_verification.code.required':
    'Kód z SMS musí být vyplněný',
  'to_sell_survey.steps.sms_verification.code.invalid':
    'Kód z SMS musí být čtyřmístné číslo.',
  'to_sell_survey.steps.sms_verification.code.placeholder':
    'Zadejte kontrolní kód',
  'to_sell_survey.steps.sms_verification.submit': 'Ověřit tel. číslo',
  'to_sell_survey.steps.sms_verification.edit': 'Upravit tel. číslo',
  'to_sell_survey.steps.sms_verification.no_code_received':
    'Nedostali jste SMS kód?',
  'to_sell_survey.steps.sms_verification.request_new_code': 'Poslat nový kód',
  'to_sell_survey.steps.sms_verification.new_code_requested':
    'Kód byl úspěšně odeslán. Doručení může pár minut trvat.',
  'to_sell_survey.steps.sms_verification.error.request_failed':
    'Došlo k chybě na naší straně. Zkuste to prosím znovu později.',
  'to_sell_survey.steps.sms_verification.error.verification_failed':
    'Zadaný kód je nesprávný.',
};
